export interface AppConfigs {
  enableDeliveryAddressStep?: boolean;
  contactSupportConfigs: {
    viewContextHistoryStateLimit: number;
    maxSizeFileUploadBytes: number;
    allowedFilesAmountPerTicket: number;
  };
}

export const defaultAppConfigs: AppConfigs = {
  enableDeliveryAddressStep: false, //phase 1
  contactSupportConfigs: {
    viewContextHistoryStateLimit: 10,
    maxSizeFileUploadBytes: 10 * 1024 * 1024, // 10 MB
    allowedFilesAmountPerTicket: 8,
  },
};
